<mat-card-header>
	<mat-card-title class="h5">
		Permissions
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon>
	</mat-card-title>
</mat-card-header>
<mat-divider> </mat-divider>


<div *ngIf="!isLoading" class="margin-top-md">
	<div class="row">
		<mat-form-field class="col-lg-12">
			<mat-label>
				Filter
			</mat-label>
			<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
				(ngModelChangeDebounced)="setFilter()" />
		</mat-form-field>
		<div class="col-lg-12">
			<mat-checkbox class="margin-vertical-md" [(ngModel)]="showActiveOnly" color="primary"
				(ngModelChangeDebounced)="setFilter()">Active Only
			</mat-checkbox>
		</div>
	</div>

	<mat-accordion class="example-headers-align" multi>
		<mat-expansion-panel
			*ngFor="let parentFeature of featuresBuilt | orderBy: 'NAME'; let parentFeatureIndex = index"
			(opened)="openGroup(parentFeatureIndex)" (closed)="closeGroup(parentFeatureIndex)"
			[hidden]="parentFeature.tableDataSource.filteredData.length === 0">
			<mat-expansion-panel-header>
				<mat-panel-title>
					{{parentFeature.NAME}} ({{parentFeature.tableDataSource ?
					(parentFeature.tableDataSource.filteredData.length < parentFeature.CHILDREN.length ?
						parentFeature.tableDataSource.filteredData.length + '/' : '' ) : ''
						}}{{parentFeature.CHILDREN.length}}) </mat-panel-title>
			</mat-expansion-panel-header>

			<mat-table id="permission-table" [dataSource]="parentFeature.tableDataSource"
				class="table-responsive mat-elevation-z1" matSort *ngIf="parentFeature.isOpen">

				<ng-container matColumnDef="NAME">
					<mat-header-cell *matHeaderCellDef></mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div>{{element.NAME}}</div>
					</mat-cell>
				</ng-container>

				<ng-container [matColumnDef]="role.NAME!" *ngFor="let role of roles">
					<mat-header-cell *matHeaderCellDef class="row"> {{role.NAME}} </mat-header-cell>
					<mat-cell *matCellDef="let element" class="row text-center"
						[matTooltip]="role.NAME! + ' | ' + element.NAME!" matTooltipPosition="above"
						matTooltipClass="multiline-tooltip">
						<mat-checkbox [(ngModel)]="element[role.ID!]" color="primary"
							(change)="togglePermission($event, role, element)">
						</mat-checkbox>
						<!-- <mat-icon *ngIf="element[role.ID!]">check_box</mat-icon>
						<mat-icon *ngIf="!element[role.ID!]">check_box_outline_blank</mat-icon> -->
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
			</mat-table>

		</mat-expansion-panel>
	</mat-accordion>


</div>

<div class="margin-lg">&nbsp;</div>

<mat-card-header>
	<mat-card-title class="h5">
		Workflow State Permissions
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon>
	</mat-card-title>
</mat-card-header>
<mat-divider> </mat-divider>


<div *ngIf="!isLoading" class="margin-top-md">
	<div class="row">
		<mat-form-field class="col-lg-12">
			<mat-label>
				Filter
			</mat-label>
			<input matInput id="workflowFilter" name="workflowFilter" type="string" [(ngModel)]="workflowFilter"
				(ngModelChangeDebounced)="setWorkflowFilter()" />
		</mat-form-field>
	</div>

	<mat-accordion class="example-headers-align" multi>
		<mat-expansion-panel *ngFor="let workflow of workflows | orderBy: 'NAME'; let workflowIndex = index"
			(opened)="openWorkflowGroup(workflowIndex)" (closed)="closeWorkflowGroup(workflowIndex)">
			<mat-expansion-panel-header>
				<mat-panel-title>
					{{workflow.NAME}} ({{workflow.tableDataSource ?
					(workflow.tableDataSource.filteredData.length < workflow.STATES.length ?
						workflow.tableDataSource.filteredData.length + '/' : '' ) : '' }}{{workflow.STATES.length}})
						</mat-panel-title>
			</mat-expansion-panel-header>

			<mat-table id="permission-table" [dataSource]="workflow.tableDataSource"
				class="table-responsive mat-elevation-z1" matSort *ngIf="workflow.isOpen">

				<ng-container matColumnDef="NAME">
					<mat-header-cell *matHeaderCellDef></mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div>{{element.NAME}}</div>
					</mat-cell>
				</ng-container>

				<ng-container [matColumnDef]="role.NAME!" *ngFor="let role of roles">
					<mat-header-cell *matHeaderCellDef class="row"> {{role.NAME}} </mat-header-cell>
					<mat-cell *matCellDef="let element" class="row text-center"
						[matTooltip]="role.NAME! + ' | ' + element.NAME!" matTooltipPosition="above"
						matTooltipClass="multiline-tooltip">
						<mat-checkbox [(ngModel)]="element[role.ID!]" color="primary"
							(change)="toggleWorkflowStatePermission($event, role, element)">
						</mat-checkbox>
						<!-- <mat-icon *ngIf="element[role.ID!]">check_box</mat-icon>
						<mat-icon *ngIf="!element[role.ID!]">check_box_outline_blank</mat-icon> -->
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
			</mat-table>

		</mat-expansion-panel>
	</mat-accordion>


</div>